import moment from "moment";
import { ClientIntakeData } from "./types";

/* Serialize from React Hook Form to Server */

const serializeClientSSN = (ssn: string) => ssn.replaceAll(/-/g, "");

const serializeClientDate = (date: string) =>
  moment(date, "MM/DD/YYYY").format("YYYY-MM-DD");

const serializeClientPhoneNumber = (phoneNumber: string) =>
  phoneNumber.replaceAll(/\(|\)|\s|-/g, "");

/* Deserialize from Server to React Hook Form */

const deserializeClientSSN = (ssn: string) =>
  ssn.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");

const deserializeClientDate = (date: string | undefined) =>
  date ? moment(date, "YYYY-MM-DD").format("MM/DD/YYYY") : "";

const deserializeClientPhoneNumber = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return "";

  // Remove duplicate +1 prefix: "+119254087324" -> "+19254087324"
  let cleaned = phoneNumber.replace(/\s/g, ""); // strip spaces first

  // Check for duplicate "+1" prefix: starts with "+11" and has 11+ digits after "+"
  if (cleaned.startsWith("+11")) {
    const digitsAfterPlus = cleaned.slice(1); // Remove the "+"

    // If we have 11+ digits after the "+", it's likely a duplicate prefix
    // Valid US number: +1 + 10 digits = 11 chars total (10 after "+1")
    // Duplicate prefix: +1 + 1 + 10 digits = 12 chars total (11 after "+1")
    if (digitsAfterPlus.length >= 11) {
      // Check if removing the first "1" results in a valid E.164 number (10-14 digits)
      const withoutDuplicatePrefix = digitsAfterPlus.slice(1);
      if (
        withoutDuplicatePrefix.length >= 10 &&
        withoutDuplicatePrefix.length <= 14
      ) {
        cleaned = "+" + withoutDuplicatePrefix;
      }
    }
  }

  // Format: "+19254087324" -> "+1 (925) 408 7324"
  return cleaned.replace(/(\+\d{1})(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3 $4");
};

const serializeClient = (client: ClientIntakeData) => {
  return {
    ...client,
    HAS_FINRA_ASSOCIATION: [true, "true"].includes(
      client.HAS_FINRA_ASSOCIATION as string | boolean
    )
      ? true
      : false,
    PHONE_NUMBER:
      client.PHONE_NUMBER && serializeClientPhoneNumber(client.PHONE_NUMBER),
    DRIVER_LICENSE_EXP:
      client.DRIVER_LICENSE_EXP &&
      serializeClientDate(client.DRIVER_LICENSE_EXP),
    DOB: client.DOB && serializeClientDate(client.DOB),
    SSN: client.SSN && serializeClientSSN(client.SSN),
  };
};

export {
  serializeClient,
  serializeClientSSN,
  serializeClientPhoneNumber,
  serializeClientDate,
  deserializeClientSSN,
  deserializeClientPhoneNumber,
  deserializeClientDate,
};
